import { paymentMethodIconMap } from '@change/ds-core-ui';

type PaymentData = {
	type: string;
	brand?: string;
};

type IconVariant = keyof typeof paymentMethodIconMap;

const DEFAULT_ICON_VARIANT = 'visa';

/*
Stripe can return these brands: https://docs.stripe.com/api/cards/object#card_object-brand
*/
const STRIPE_BRAND_TO_ICON_VARIANT_MAP: Record<string, IconVariant> = {
	'American Express': 'americanexpress',
	MasterCard: 'mastercard',
	Discover: 'discover',
	JCB: 'jcb',
	Visa: 'visa',
	Unknown: DEFAULT_ICON_VARIANT,
	'Diners Club': DEFAULT_ICON_VARIANT,
	'Cartes Bancaires': DEFAULT_ICON_VARIANT,
	'Eftpos Australia': DEFAULT_ICON_VARIANT,
	Girocard: DEFAULT_ICON_VARIANT,
};

export const getIconVariant = (paymentData: PaymentData): IconVariant => {
	const availableVariants = Object.keys(paymentMethodIconMap);

	/* check if apple pay, google pay or paypal */
	const matchingPaymentType = availableVariants.find((key) => key === paymentData.type.toLowerCase());
	if (matchingPaymentType) return matchingPaymentType as IconVariant;

	/* this should be saved credit card. check stripe brand map */
	if (!paymentData.brand) {
		return DEFAULT_ICON_VARIANT;
	}

	if (Object.keys(STRIPE_BRAND_TO_ICON_VARIANT_MAP).includes(paymentData.brand)) {
		return STRIPE_BRAND_TO_ICON_VARIANT_MAP[paymentData.brand];
	}

	return DEFAULT_ICON_VARIANT;
};
